import React from "react";
import { Table, TableBody, TableContainer, TableHead, TableRow } from "@mui/material";
import PageHeader from "../Layout/Header/PageHeader";
import { UserRightsTableCell } from "./UserRightsTableCell.styled";
import { userTasks } from "./UserTasks";

const tableStyle = {
  border: "1px solid #ccc",
  marginBottom: "2rem",
};

export function UserRights() {
  return (
    <>
      <PageHeader headerText="User Rights" />
      <TableContainer style={tableStyle}>
        <Table>
          <TableHead>
            <TableRow>
              <UserRightsTableCell isHeader width="50%" textAlign="left">
                Task
              </UserRightsTableCell>
              <UserRightsTableCell isHeader>Super User</UserRightsTableCell>
              <UserRightsTableCell isHeader>Read Only User</UserRightsTableCell>
              <UserRightsTableCell isHeader>Network Planner</UserRightsTableCell>
              <UserRightsTableCell isHeader>Risk Manager</UserRightsTableCell>
              <UserRightsTableCell isHeader>Launch Team</UserRightsTableCell>
              <UserRightsTableCell isHeader>Calculation Trigger</UserRightsTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {userTasks.map((task) => (
              <TableRow key={task.id}>
                <UserRightsTableCell textAlign="left">{task.name}</UserRightsTableCell>
                <UserRightsTableCell>{task.superUser ? "X" : ""}</UserRightsTableCell>
                <UserRightsTableCell>{task.readOnlyUser ? "X" : ""}</UserRightsTableCell>
                <UserRightsTableCell>{task.networkPlanner ? "X" : ""}</UserRightsTableCell>
                <UserRightsTableCell>{task.riskManager ? "X" : ""}</UserRightsTableCell>
                <UserRightsTableCell>{task.launchTeam ? "X" : ""}</UserRightsTableCell>
                <UserRightsTableCell>{task.calculationTrigger ? "X" : ""}</UserRightsTableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}
